import { useMemo, useState } from "react";

import { modelGenders } from "@/features/model/const/modelGenders";
import { GenderEnum } from "@/generated/graphql-hooks";

type GenderTabsProps = {
  defaultValue?: GenderEnum;
  femaleCount?: number;
  maleCount?: number;
  hideNonDefaultTab?: boolean;
};

export const useGenderTabs = ({
  defaultValue,
  femaleCount,
  maleCount,
  hideNonDefaultTab,
}: GenderTabsProps) => {
  const [currentTab, setCurrentTab] = useState(
    defaultValue ?? GenderEnum.Female,
  );

  const tabs = useMemo(() => {
    const femaleTab = {
      label: modelGenders[GenderEnum.Female],
      name: GenderEnum.Female,
      count: femaleCount,
    };

    const maleTab = {
      label: modelGenders[GenderEnum.Male],
      name: GenderEnum.Male,
      count: maleCount,
    };

    if (hideNonDefaultTab && !!defaultValue) {
      if (defaultValue === GenderEnum.Female) {
        return [femaleTab];
      }

      return [maleTab];
    }

    return [femaleTab, maleTab];
  }, [femaleCount, maleCount, defaultValue, hideNonDefaultTab]);

  return {
    tabs,
    currentTab,
    setCurrentTab,
  };
};
